// src/components/SelectorFraccionamientoRapido.js
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FaExchangeAlt, FaBuilding, FaChevronDown, FaCheck } from 'react-icons/fa';
import './SelectorFraccionamientoRapido.css';

const SelectorFraccionamientoRapido = () => {
    const { userData, fraccionamientoId, cambiarFraccionamiento } = useAuth();
    const [options, setOptions] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const containerRef = useRef(null);

    // Extraer lista de fraccionamientos asignados
    useEffect(() => {
        let isMounted = true;
        const loadFraccionamientos = async () => {
            if (!userData) {
                setLoading(false);
                return;
            }

            const rawList = new Set();
            if (userData.fraccionamientoId) rawList.add(userData.fraccionamientoId);
            if (Array.isArray(userData.fraccionamientosAsignados)) {
                userData.fraccionamientosAsignados.forEach(id => {
                    if (typeof id === 'string') rawList.add(id);
                    else if (id && id.id) rawList.add(id.id);
                });
            }

            const list = Array.from(rawList);
            if (list.length <= 1) {
                setOptions([]);
                setLoading(false);
                return;
            }

            try {
                const promises = list.map(async (id) => {
                    try {
                        const snap = await getDoc(doc(db, 'fraccionamientos', id));
                        if (snap.exists()) {
                            const data = snap.data() || {};
                            const configRecibos = data.configuracionRecibos || {};
                            const nombre = data.nombre || data.condominioNombre || configRecibos.condominioNombre || `Fraccionamiento ${id}`;
                            return { id, nombre };
                        }
                    } catch (e) {
                        console.warn(`SelectorFraccionamientoRapido: Error en fracc ${id}`, e);
                    }
                    return { id, nombre: `Fraccionamiento ${id}` };
                });

                const res = await Promise.all(promises);
                if (isMounted) {
                    setOptions(res);
                    setLoading(false);
                }
            } catch (err) {
                console.error('SelectorFraccionamientoRapido: Error cargando fraccionamientos:', err);
                if (isMounted) setLoading(false);
            }
        };

        loadFraccionamientos();

        return () => { isMounted = false; };
    }, [userData]);

    // Cerrar al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (loading || options.length <= 1) return null;

    const currentOption = options.find(o => o.id === fraccionamientoId) || options[0] || { nombre: 'Seleccionar' };

    const handleSelect = (id) => {
        cambiarFraccionamiento(id);
        setIsOpen(false);
    };

    return (
        <div className="selector-fracc-rapido-container" ref={containerRef}>
            <button
                type="button"
                className={`btn-selector-fracc-rapido ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                title="Cambiar fraccionamiento activo"
            >
                <FaExchangeAlt className="icon-exchange" />
                <span className="current-fracc-name">{currentOption.nombre}</span>
                <FaChevronDown className="icon-arrow" />
            </button>

            {isOpen && (
                <div className="dropdown-fracc-menu">
                    <div className="dropdown-fracc-header">
                        <FaBuilding />
                        <span>Tus Fraccionamientos</span>
                    </div>
                    <div className="dropdown-fracc-list">
                        {options.map((item) => {
                            const isSelected = item.id === fraccionamientoId;
                            return (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`dropdown-fracc-item ${isSelected ? 'selected' : ''}`}
                                    onClick={() => handleSelect(item.id)}
                                >
                                    <span>{item.nombre}</span>
                                    {isSelected && <FaCheck className="item-check" />}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SelectorFraccionamientoRapido;
